import script from "./PlatformaUpdateBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./PlatformaUpdateBanner.vue?vue&type=script&setup=true&lang=js"

import "./PlatformaUpdateBanner.vue?vue&type=style&index=0&id=2c30fd06&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c30fd06"]])

export default __exports__